module.exports = __webpack_public_path__ + "static/media/ctc-fs-new-lumbar@3x.e650e238.png";